import { io } from 'socket.io-client';
import { API_BASE_URL } from '../config/api';

let socketInstance = null;

/** Purpose: return the app-wide authenticated Socket.IO connection. Why: Inbox and notifications share one resilient connection and refresh its token after session changes. */
export const getSocket = () => {
  const token = localStorage.getItem('token') || '';
  if (socketInstance) {
    // The singleton can be created before login/session restoration completes.
    // Keep auth current and reconnect so Inbox never remains on a stale token.
    if (socketInstance.auth?.token !== token) {
      socketInstance.auth = { ...(socketInstance.auth || {}), token };
      if (socketInstance.connected) socketInstance.disconnect();
      socketInstance.connect();
    } else if (!socketInstance.connected && !socketInstance.active) {
      socketInstance.connect();
    }
    return socketInstance;
  }

  socketInstance = io(API_BASE_URL || window.location.origin, {
    transports: ['websocket', 'polling'],
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    auth: {
      token,
    },
  });

  return socketInstance;
};

/** Purpose: close and clear the shared socket. Why: logout must stop authenticated live events and allow a later session to create a fresh connection. */
export const disconnectSocket = () => {
  if (socketInstance) {
    socketInstance.disconnect();
    socketInstance = null;
  }
};
